import { clsx } from "clsx";
import type { ClassValue } from "clsx";
import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { renderToString } from "react-dom/server";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function extractStringFromReactNode(node: ReactNode, separator: string = "") {
  const htmlString = renderToString(node);
  const textSegments = htmlString
    .replace(/<!--[\s\S]*?-->/g, "")
    .split(/<[^>]+>/)
    .filter((segment) => segment.trim() !== "");
  return textSegments.join(separator);
}
